// Existing vendor versions, bundled as CommonJS with explicit browser globals where their outer wrappers require them.
import AOS from 'resources/frontend/web/js/vendors/aos.cjs';
import 'resources/frontend/web/js/vendors/awselect.cjs';
import 'resources/frontend/web/js/vendors/jquery-luna.cjs';
import 'resources/frontend/web/js/vendors/jquery-ui.min.cjs';
import 'resources/frontend/web/js/vendors/jssocials.min.cjs';
import simpleParallax from 'resources/frontend/web/js/vendors/simpleparralax.cjs';
import 'resources/frontend/web/js/vendors/slick.cjs';
import WaveSurfer from 'resources/frontend/web/js/vendors/wavesurfer.min.cjs';

// These interfaces are also used by progressive navigation/player controllers.
Object.assign(window, { AOS, simpleParallax, WaveSurfer });
export { AOS, simpleParallax, WaveSurfer };
